var map = {
	"./CatalogueList.vue": "0e4d",
	"./CourseCard.vue": "8f57",
	"./DownloadList.vue": "e29a",
	"./GlobalBack.vue": "970a",
	"./GlobalEmpty.vue": "df51",
	"./GlobalTitle.vue": "afc9",
	"./SwipeCard.vue": "eba4",
	"./page-loading.vue": "ae21"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2323";